import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    status: {
        label: "",
        code: ""
    },
    statusList: []
}

const status = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default status;